import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {
  ADDRESS_TYPE_PRIMARY,
  CREATE_LOGIN_PATH,
  ERROR_PATH, FUNDING_AVAILABLE_KEY, FUNDING_PATH, JOINT_MAINTENANCE_CREATE_LOGIN_PATH,
  PERSONAL,
  PHONETYPE_MOBILE,
  SUCCESS_PATH,
  TAXID_FLAG
} from "../shared/constants";
import {FacadeService} from "../shared/service-facade/facade.service";
import {
  Addresses,
  Applicants,
  EnrollmentControllerService,
  OlbEnrollmentRequest,
  PhoneNumbers,
} from "skyhopper-api";
import {
  ApplicantIdentityResponseRequest,
  ApplicantRequest,
  ApplicationDetailLog,
  ApplicationLogDetailsRequest,
  ApplicationLogsRequest, ApplicationLogStepRequest,
  ApplicationProduct,
  Log,
  Step
} from "leia-api";
import {UtilitiesService} from "../shared/services/utilities.service";
import {OnboardingRequest} from "../shared/model/onboarding-request.model";
import {DatePipe} from '@angular/common';
import {RelationshipCode} from "../shared/model/relationshipCode.model";
import {CoreService, PageProps} from "../shared/services/core.service";
import {ApplicantType} from "../signup/models/applicant-type";
import {ProcessService} from "./process.service";
import {SocureStatus} from "../shared/model/socure-status";
import {ReferenceCode} from "./models/referenceCode";
import NameEnum = Step.NameEnum;
import StateEnum = Step.StateEnum;
import StatusEnum = ApplicationLogsRequest.StatusEnum;
import {environment} from "../../environments/environment";
import {SocureProcessFlow} from "../shared/model/socure-process-flow";
import {AlloyOutcome} from "../shared/model/alloy-outcome";
import { MainLayoutService } from '../shared/services/main-layout.service';
import { SectionStatusService } from '../status-tracker/section-status.service';
import { Sections, SectionStates } from '../status-tracker/model/section-status';
import OnboardingSourceEnum = ApplicationLogStepRequest.OnboardingSourceEnum;
import OnboardingStepEnum = ApplicationLogStepRequest.OnboardingStepEnum;
import OnboardingStateEnum = ApplicationLogStepRequest.OnboardingStateEnum;
import {DocumentCapture} from "../shared/model/document-capture.enum";
import ServiceTypeEnum = ApplicantIdentityResponseRequest.ServiceTypeEnum;

//const mParticle = require("@mparticle/web-sdk");
@Component({
  selector: 'app-process',
  templateUrl: './process.component.html',
  styleUrls: ['./process.component.scss']
})
export class ProcessComponent implements OnInit {

  shoppingCartOnboardingRequest: OnboardingRequest;
  executeDocumentCapture: boolean = false;
  displayDefaultProcessingArea: boolean = true;
  executeAlloyEvaluate: boolean = false;
  executeAlloyDocumentVerification : boolean = false;
  approvedAlloyEvaluationCount: number = 0;
  completedSocureDocumentCaptureCount: number = 0;
  approvedAlloyDocumentVerifyCount: number = 0;
  noOfApplicantsRequiredKycCheck : number = 0;
  noOfApplicantsRequiredAlloyEvaluate : number = 0;
  entireAlloyExecutionCallCount : number = 0;
  private alloyJourneyEnrollmentStarted: boolean = false;
  socureDialogPresented : boolean = false;
  isInJointMaintenanceFlow = false;
  alloyDocV = DocumentCapture.Alloy;
  socureDocV = DocumentCapture.Socure;
  @ViewChild('processingCard', { static: false }) processingCard!: ElementRef;

  constructor(
    public router: Router,
    private facade: FacadeService,
    private utils: UtilitiesService,
    public datepipe: DatePipe,
    private enrollmentControllerService: EnrollmentControllerService,
    private coreService: CoreService,
    public processService: ProcessService,
    private mainLayout: MainLayoutService,
    private appStateService: SectionStatusService,
  ) {
    this.shoppingCartOnboardingRequest = new OnboardingRequest();
  }

  ngOnInit(): void {
    this.coreService.disableBackButton();
    this.processService.displayDefaultProcessingArea$.next(true);

    this.mainLayout.setPageTitle(`Verify Your Identity`);

    this.appStateService.updateStatusTrackerSectionStatus(Sections.ReviewApplication, SectionStates.complete);

    if(this.facade.isInJointMaintenanceFlow()) {
      this.isInJointMaintenanceFlow = true;
    }

    let props = new PageProps();
    props.title = null;
    props.isHomePage = false;
    this.coreService.setPageProps(props)

    //comment mParticle, CDP scripts are live, remove the code later
    // mParticle.default.logPageView(
    //   "Step 4 - Socure",
    //   {page: window.location.toString()}
    // );

    if(!this.canProceedToEnrollmentWithoutKycChecks()) {
      this.processService.alloyEvaluateProcessComplete.subscribe(next => {
        this.executeAlloyEvaluate = false;
        this.approvedAlloyEvaluationCount++;

        if(this.noOfApplicantsRequiredAlloyEvaluate === 0 || this.approvedAlloyEvaluationCount === this.noOfApplicantsRequiredAlloyEvaluate) {
          this.assignAlloyEntityTokenToApplicants();
          this.entireAlloyExecutionCallCount++;

          if (this.entireAlloyExecutionCallCount === 1) this._checkAndSetDocumentCapture();
        }
      });

      this.processService.socureDocumentProcessComplete.subscribe(next => {
        this.completedSocureDocumentCaptureCount++;

        if(this.completedSocureDocumentCaptureCount === this.noOfApplicantsRequiredKycCheck) {
          this.executeDocumentCapture = false;
          this.executeAlloyDocumentVerification = true;
          this.approvedAlloyEvaluationCount = 0;
          this.processService.displayDefaultProcessingArea$.next(true);
        }
      });

      this.processService.alloyDocumentVerifyProcessComplete.subscribe(next => {
        this.processService.displayDefaultProcessingArea$.next(true);

        this.mainLayout.setPageTitle(`Processing Your Application`);

        this.executeAlloyDocumentVerification = false;
        this.approvedAlloyDocumentVerifyCount++;

        const applicants = this.facade.getShoppingCartApplicationLogsRequest().applicants;
        const isAlloyDocumentCapture = this.processService.documentCaptureService$.getValue() === DocumentCapture.Alloy;
        if(isAlloyDocumentCapture && (!!applicants && applicants.length > 1)){
          this.approvedAlloyDocumentVerifyCount++;
        }

        //Fix to not allow the applications to get enrolled if one of the applicant alloy evaluate returns back Manual review.
        //INC-222867 Fix
        let manualReviewFound : boolean = false;
        this.processService.alloyEvaluateOutcomeMap.forEach((value, key) => {
          if(value === AlloyOutcome.ManualReview) manualReviewFound = true;
        });

        if(this.approvedAlloyDocumentVerifyCount === this.noOfApplicantsRequiredKycCheck) {
          this.entireAlloyExecutionCallCount++;
          if(!manualReviewFound && (this.entireAlloyExecutionCallCount === 2 || isAlloyDocumentCapture)){

            this.performEnrollment();
          }
        }
      });

      // Subscribe to an Event Emitter that the Alloy SDK Component will trigger when the Journey has completed.
      this.processService.alloyJourneyProcessComplete.subscribe(next => {
        if (!this.alloyJourneyEnrollmentStarted && this.canEnrollAfterAlloyJourney()) {
          this.alloyJourneyEnrollmentStarted = true;
          this.executeDocumentCapture = false;
          this.processService.displayDefaultProcessingArea$.next(true);
          this.mainLayout.setPageTitle(`Processing Your Application`);
          void this.performEnrollment();
        }
      });

      this.setAlloyByPassAttributes().then(value => {
        if(this.processService.documentCaptureService$.getValue() === DocumentCapture.Alloy) {
          this.processService.displayDefaultProcessingArea$.next(false);
          this.executeDocumentCapture = true;
        } else {
          this.executeAlloyEvaluate = this.isAlloyEvaluateRequired();

          if(!this.executeAlloyEvaluate) this.processService.alloyEvaluateProcessComplete.emit();
        }
      });
    } else {
      this.mainLayout.setPageTitle(`Processing Your Application`);
      this.processService.displayDefaultProcessingArea$.next(true);

      // Calling enroll service without kyc checks
      this.performEnrollment();
    }
  }

  ngAfterViewInit() {
    if (this.processingCard && this.processingCard.nativeElement) {
      this.processingCard.nativeElement.focus();
    }
  }

  assignAlloyEntityTokenToApplicants() {
    let applicationRequest = this.facade.getShoppingCartApplicationLogsRequest();
    applicationRequest.applicants?.forEach(value => {
      value.entityToken = this.processService.alloyEntityTokenMap.get(value.applicantId!);
    });
    this.facade.setShoppingCartApplicationLogsRequest(applicationRequest);
  }

  async performEnrollment(): Promise<void> {
    this.shoppingCartOnboardingRequest = this.facade.getShoppingCartOnboardingRequest();

    const productName = "";
    let accountNumbers: string;
    const olbEnrollmentRequest = {} as OlbEnrollmentRequest;

    const logs: Log[] = [];
    const applicationLogDetailsRequests: ApplicationLogDetailsRequest[] = [];

    const brandName = this.coreService.brandNameSubject.value;

    olbEnrollmentRequest.sessionId = this.facade.getSessionId();
    olbEnrollmentRequest.primaryApplicant = this.getApplicants()![0];
    olbEnrollmentRequest.brandName = brandName;
    this.facade.addStorageItem("olb-enrollment-request", JSON.stringify(olbEnrollmentRequest));

    try {
      const response = await this.enrollmentControllerService.enrollMultiProduct("", this.facade.getSessionId()).toPromise();
      if (!response) {
        return;
      }
      let linkedAccount: string | undefined = "";
      //Set InterestPlanCode from Application Log table, To address if the interestplan code is empty
      const applicationLogResponse: ApplicationDetailLog = await this.facade.getApplicationLog(this.facade.getSessionId()).toPromise();
      if(applicationLogResponse){
        applicationLogResponse.status=response.status;
        linkedAccount = applicationLogResponse.linkedAccountNumber;
        let applicationRequest = this.facade.getShoppingCartApplicationLogsRequest();
        applicationRequest.products = applicationLogResponse.products;
        applicationRequest.status = applicationLogResponse.status! as StatusEnum;
        applicationRequest.rcCode = applicationLogResponse.rcCode;
        this.facade.setShoppingCartApplicationLogsRequest(applicationRequest);
      }

      if (response.rcCode) {
        await this.facade.processOnboardingUnderReview(response.rcCode as ReferenceCode).toPromise();
        this.coreService.navigate(`/${ERROR_PATH}`);
        return;
      }

      // await this._checkAllProductSettingsLoaded(applicationLogResponse.products!);
      this.facade.mapEnrolledAccounts(response, linkedAccount);

      const primaryApplicant = this.shoppingCartOnboardingRequest.applicants.find(applicant => applicant.applicantType === ApplicantType.Primary);

      const {firstName} = primaryApplicant!.tellUsAboutYourself;
      const {isEnrolledInOLB} = primaryApplicant!.customerInfo;
      const {userName} = this.shoppingCartOnboardingRequest.customerLogin;

      logs.push(this.utils.createLog("SKH", JSON.stringify(response)));
      applicationLogDetailsRequests.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.Skyhopper, JSON.stringify(response)));

      accountNumbers = response.accounts!
        .filter(({accountNumber}) =>
          UtilitiesService.getLastNCharacters(accountNumber, 4) !== UtilitiesService.getLastNCharacters(linkedAccount, 4)
        ) // Do not include linked account
        .map(account => account.accountNumber).join(",");

      await this._updateApplication(
        NameEnum.SignatureEnrollment,
        OnboardingStepEnum.SignatureEnrollment,
        StateEnum.Success,
        OnboardingStateEnum.Success,
        applicationLogResponse.status as StatusEnum,
        applicationLogResponse.rcCode as ReferenceCode,
        logs,
        applicationLogDetailsRequests
      );

      await this.facade.processOnboarding(productName!, accountNumbers, firstName!, userName!, isEnrolledInOLB!).toPromise()
      let nextStepPath = `/${SUCCESS_PATH}`;

      if(this.facade.getStorageItemAsBoolean(FUNDING_AVAILABLE_KEY)){
        nextStepPath = `/${FUNDING_PATH}`
      }

      if (this.facade.notEnrolledInOLB.getValue()) {
        nextStepPath = this.isInJointMaintenanceFlow
          ? `/${JOINT_MAINTENANCE_CREATE_LOGIN_PATH}`
          : `/${CREATE_LOGIN_PATH}`;
      }

      this.coreService.navigate(nextStepPath);

    } catch (error) {
      console.log('error',error);

      logs.push(this.utils.createLog("SKH", JSON.stringify(error)));
      logs.push(this.utils.createLog("BB8", "Enrollment failed."));

      applicationLogDetailsRequests.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.Skyhopper, JSON.stringify(error)));
      applicationLogDetailsRequests.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.Bb8, "Enrollment failed."));

      await this._updateApplication(NameEnum.CustomerEnrollment, OnboardingStepEnum.CustomerEnrollment, StateEnum.Fail, OnboardingStateEnum.Fail, StatusEnum.Error, ReferenceCode.InternalFailure, logs, applicationLogDetailsRequests);

      await this.facade.processOnboardingUnderReview(ReferenceCode.InternalFailure).toPromise();
      this.coreService.navigate(`/${ERROR_PATH}`);
    }
  }

  private async _checkAllProductSettingsLoaded(products: ApplicationProduct[]): Promise<void> {
    products.forEach(async product => {
      if (!this.facade.productSettings.get(product.productUID!)) {
        await this.facade.getAndSetProductSettings(product.productUID!);
      }
    });
  }

  getApplicants() {
    let applicantsList: Array<Applicants> = [];

    let applicationRequest = this.facade.getShoppingCartApplicationLogsRequest();

    const {userName, password} = this.shoppingCartOnboardingRequest.customerLogin;

    let olbGroupId = Number(this.facade.getStorageItem("olbGroupId"));

    applicationRequest.applicants?.forEach(applicant => {
      const {
        firstName, middleName, lastName, suffix, email, dateOfBirth, ssn, primary, phoneNumber,
        isExistingCustomer, isEnrolledOLB, isKyc, applicantId, employeeType
      } = applicant;
      const { streetAddress, streetAddress1, city, state, zip } = applicant.addresses![0];
      let applicants = {} as Applicants;

      let contactList: Array<PhoneNumbers> = [];
      let addressList: Array<Addresses> = [];

      let phoneNumbers = {} as PhoneNumbers;

      phoneNumbers.number = phoneNumber!;
      phoneNumbers.type = PHONETYPE_MOBILE;

      contactList.push(phoneNumbers);

      let address = {} as Addresses;

      address.state = state!;
      address.city = city;
      address.country = "US"; // Check
      address.street = `${streetAddress!.split(/ (.+)/)[1]}`;
      address.houseNumber = streetAddress!.split(/ (.+)/)[0];
      address.zipCode = zip!;
      address.type = ADDRESS_TYPE_PRIMARY;

      // Bug 396867: send address line 2 in enrollment request
      address.address2 = streetAddress1;

      addressList.push(address);

      const shortName = `${lastName} ${firstName}`;

      //Set Customer Info
      applicants.isExistingCustomer = isExistingCustomer!;
      applicants.isEnrolledInOlb = isEnrolledOLB!;
      applicants.requiresKyc = isKyc!;
      applicants.applicantId = applicantId!;
      applicants.firstName = firstName!;
      applicants.middleName = middleName!;
      applicants.lastName = lastName!;
      applicants.nameSuffix = suffix!;
      applicants.emailAddress = email!;
      applicants.shortName = shortName.toUpperCase().substring(0, 17); //check
      applicants.birthDate = dateOfBirth!;
      applicants.taxIdNumber = ssn!.replace(/-/g, '');
      applicants.taxIdFlag = TAXID_FLAG;
      applicants.customerType = PERSONAL;
      applicants.isPrimary = primary!;
      applicants.userName = primary ? userName : null;
      applicants.pwd = password;
      applicants.groupId = olbGroupId;
      applicants.requiresPasswordReset = false;
      applicants.phoneNumbers = contactList;
      applicants.employeeType = employeeType!;

      applicants.isMinor = false;
      if(applicant.primary && this.facade.getIsMinor()) applicants.isMinor = true;

      applicants.addresses = addressList;

      applicantsList.push(applicants);
    });

    return applicantsList;
  }

  private _updateApplication(stepName: NameEnum, onboardingStepEnum: OnboardingStepEnum, stepState: StateEnum, onboardingStateEnum: OnboardingStateEnum, appState: StatusEnum, rcCode: ReferenceCode | undefined, logs: Log[], applicationLogDetailsRequests: ApplicationLogDetailsRequest[]): Promise<void> {
    let applicationRequest = this.facade.getShoppingCartApplicationLogsRequest();

    let step = this.utils.createStep(stepName, stepState, logs);

    let applicationLogStepRequest = this.utils.createApplicationLogStepRequest(onboardingStepEnum, onboardingStateEnum, OnboardingSourceEnum.Bb8, applicationLogDetailsRequests);
    if (rcCode) applicationLogStepRequest.rcCode = rcCode.toString();

    applicationRequest.step = step;
    applicationRequest.applicationLogStepRequest = applicationLogStepRequest;

    applicationRequest.status = appState;
    this.facade.setShoppingCartApplicationLogsRequest(applicationRequest);
    return this.facade.updateApplication();
  }

  private _updateApplicationNoStep(appState: StatusEnum, logs: Log[], applicationLogDetailsRequests: ApplicationLogDetailsRequest[]) {
    let applicationRequest = this.facade.getShoppingCartApplicationLogsRequest();
    let step = this.utils.createEmptyStepForLogging(logs);

    applicationRequest.status = appState;
    applicationRequest.step = step;
    applicationRequest.applicationLogDetailsRequestList = applicationLogDetailsRequests;

    this.facade.setShoppingCartApplicationLogsRequest(applicationRequest);
    return this.facade.updateApplication();
  }

  routeToErrorPage(errorCode: ReferenceCode) {
    this.facade.processOnboardingError(errorCode).subscribe(() => {
      setTimeout(() => {
        this.coreService.navigate(`/${ERROR_PATH}`);
      }, 2000);
    });
  }

  private _checkAndSetDocumentCapture(): void {
    const applicationLogsRequest = this.facade.getShoppingCartApplicationLogsRequest();
    applicationLogsRequest.applicants?.forEach(value => {
      let successFound = false;
      if (value.applicantIdentityResponses !== undefined && value.applicantIdentityResponses.length > 0) {
        successFound = this._successfulApplicantIdentityResponseFound(value, ServiceTypeEnum.Socure);
      }
      if (value.isKyc && !successFound) {
        this.executeDocumentCapture = true;
        this.processService.displayDefaultProcessingArea$.next(false);
      }
    });
    this.facade.setShoppingCartApplicationLogsRequest(applicationLogsRequest);
  }

  //This method is to check if any applicant has the kyc flag true
  private canProceedToEnrollmentWithoutKycChecks(): boolean {
    let isEnrollCallWithoutKyc : boolean = true;

    this.facade.getShoppingCartOnboardingRequest().applicants?.forEach(value => {
      if(value.customerInfo.requiresKyc) {
        isEnrollCallWithoutKyc = false;
        this.noOfApplicantsRequiredKycCheck++;
      }
    });
    return isEnrollCallWithoutKyc;
  }

  private canEnrollAfterAlloyJourney(): boolean {
    const requiredApplicants = this.facade.getShoppingCartOnboardingRequest().applicants
      ?.filter(applicant => applicant.customerInfo.requiresKyc) ?? [];
    const applicationApplicants = this.facade.getShoppingCartApplicationLogsRequest().applicants ?? [];

    return requiredApplicants.length === this.noOfApplicantsRequiredKycCheck &&
      requiredApplicants.every(applicant => {
        const applicantId = applicant.applicantId;
        const applicationApplicant = applicationApplicants.find(value => value.applicantId === applicantId);
        const kycOutcome = this.processService.alloyEvaluateOutcomeMap.get(applicantId);
        const docVOutcome = this.processService.alloyDocVOutcomeMap.get(applicantId);
        const kycApproved = kycOutcome === AlloyOutcome.Approved || kycOutcome === AlloyOutcome.PreviouslyApproved;

        const docVApproved = docVOutcome === AlloyOutcome.Approved;

        return !!applicationApplicant && kycApproved && docVApproved;
      });
  }

  private setAlloyByPassAttributes(): Promise<void> {
    const logs: Log[] = [];
    const applicationLogDetailsRequests: ApplicationLogDetailsRequest[] = [];

    this.facade.getShoppingCartOnboardingRequest().applicants?.forEach(async value => {
      if(value.customerInfo.requiresKyc && !value.customerInfo.isAlloyEvaluateRequired) {
        this.processService.alloyByPassEvaluationMap.set(value.applicantId, "true");

        logs.push(this.utils.createLog("BB8", `Alloy Evaluate Bypassed. Customer approved via KYC in last 30 days. Applicant: ${value.tellUsAboutYourself.firstName} ${value.tellUsAboutYourself.lastName}. Using Previous Entity Token ID: ${value.customerInfo.alloyEntityTokenId}.`));

        const applicationLogDetailsRequests: ApplicationLogDetailsRequest[] = [];
        applicationLogDetailsRequests.push(this.utils.createApplicationLogDetailsRequest(OnboardingSourceEnum.Bb8, `Alloy Evaluate Bypassed. Customer approved via KYC in last 30 days. Applicant: ${value.tellUsAboutYourself.firstName} ${value.tellUsAboutYourself.lastName}. Using Previous Entity Token ID: ${value.customerInfo.alloyEntityTokenId}.`));

        let applicantIdentityResponseRequest: ApplicantIdentityResponseRequest = new ApplicantIdentityResponseRequest();

        applicantIdentityResponseRequest.applicantId = value.applicantId;
        applicantIdentityResponseRequest.serviceType = ServiceTypeEnum.AlloyKyc;
        applicantIdentityResponseRequest.outcome = AlloyOutcome.PreviouslyApproved;
        applicantIdentityResponseRequest.eventId = value.customerInfo.alloyEntityTokenId;

        await this.facade.createNewApplicantIdentityResponse(applicantIdentityResponseRequest).toPromise();

        const { applicantId, customerInfo } = value;
        const { alloyEntityTokenId } = customerInfo;
        this.processService.alloyEntityTokenMap.set(applicantId, alloyEntityTokenId!);
        this.processService.alloyEvaluateOutcomeMap.set(applicantId, AlloyOutcome.PreviouslyApproved);
      }
    });

    const status = this.facade.getShoppingCartApplicationLogsRequest().status!;
    return this._updateApplicationNoStep(status, logs, applicationLogDetailsRequests);
  }

  private isAlloyEvaluateRequired(): boolean {
    let isAlloyEvaluateRequired : boolean = false;

    this.facade.getShoppingCartOnboardingRequest().applicants?.forEach(value => {
      if (value.customerInfo.isAlloyEvaluateRequired) {
        isAlloyEvaluateRequired = true;
        this.noOfApplicantsRequiredAlloyEvaluate++;
      }
    });
    return isAlloyEvaluateRequired;
  }

  private _successfulApplicantIdentityResponseFound(value : ApplicantRequest, serviceType : ServiceTypeEnum) : boolean {
    let returnValue : boolean = false;
    if (value.applicantIdentityResponses !== undefined && value.applicantIdentityResponses.length > 0) {
      if(serviceType === ServiceTypeEnum.Socure) {
        if (environment.socureProcessFlow === SocureProcessFlow.UploadOnly) {
          value.applicantIdentityResponses?.forEach(applicantIdentityResponse => {
            if(applicantIdentityResponse.serviceType === serviceType && applicantIdentityResponse.outcome === SocureStatus.DocumentUploaded) returnValue = true;
          });
        } else {
          value.applicantIdentityResponses?.forEach(applicantIdentityResponse => {
            if(applicantIdentityResponse.serviceType === serviceType && applicantIdentityResponse.outcome === SocureStatus.VerifyingComplete) returnValue = true;
          });
        }
      }
      if(serviceType === ServiceTypeEnum.AlloyKyc) {
        value.applicantIdentityResponses?.forEach(applicantIdentityResponse => {
          if(applicantIdentityResponse.serviceType === serviceType && applicantIdentityResponse.outcome === AlloyOutcome.Approved) returnValue = true;
        });
      }
    }
    return returnValue;
  }
}
